module.exports = __webpack_public_path__ + "img/rq-caption.637beaaa.png";